import { otherResourcesLinks } from '../../utils';
import './Training.css'
import BiosecurityWebSeries from './Webinars/BiosecurityWebSeries/BiosecurityWebSeries';
import Resources from './Webinars/Resources';
import SpeciesSpecificSeries from './Webinars/SpeciesSpecificWebSeries/SpeciesSpecificSeries';
import Webinar from './Webinars/Webinar'
import Card from './Card.js'
import placeholder from '../photos/organic.jpeg'

const Training = () => {
    return (
        <div className='section'>
            <BiosecurityWebSeries/>
            <SpeciesSpecificSeries/>
            <Webinar
                img={placeholder} 
                sectionTitle='Other Webinars'
                date='9 May'
                title='Healthy Animals &amp; Healthy People in Agritourism'
                recording_link='https://www.youtube.com/watch?v=KOsyo5C8tQM'
                resources={<Resources resources={otherResourcesLinks} />}
            />
            <Card title='Biosecurity Plan Template'>
                <a href={`${process.env.PUBLIC_URL}/assets/documents/Template_Biosecurity Plan_UCDavis_FARM PPE_upload.docx`} target='blank'>Download Template</a>
            </Card>
                
        </div>
    )
}

export default Training;